// Content cleanup module
// Removes elements with specific classes from post content

export function initContentCleanup() {
  // Only initialize on post/page templates
  const isPostPage = document.body.classList.contains('post-template') ||
                    document.body.classList.contains('page-template') ||
                    document.querySelector('.gh-content');

  if (!isPostPage) return;

  const contentElement = document.querySelector('.gh-content');
  if (!contentElement) return;

  // Remove elements with snippet-title class
  const snippetTitles = contentElement.querySelectorAll('.snippet-title');
  snippetTitles.forEach(element => {
    element.remove();
  });

  // Replace literal "<br>" text in figcaptions with actual line breaks
  // Ghost escapes HTML in captions, so typed <br> becomes &lt;br&gt; in the DOM
  document.querySelectorAll('figcaption').forEach(caption => {
    if (caption.innerHTML.includes('&lt;br&gt;')) {
      caption.innerHTML = caption.innerHTML.replace(/&lt;br&gt;/gi, '<br>');
    }
  });
}

